import xss from 'xss';
import { z } from 'zod';
import {
  MAX_EMAIL_LENGTH,
  MAX_NAME_LENGTH,
  MIN_PHONE_DIGITS,
  PHONE_MIN_DIGIT_RATIO,
} from './constants';

export function sanitizePublicMarketplaceString(value: string): string {
  const withoutJavascriptProtocol = value.trim().replace(/javascript:/gi, '');
  return xss(withoutJavascriptProtocol, {
    whiteList: {},
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
  });
}

export const publicMarketplaceRequiredPhoneSchema = z
  .string()
  .refine((value) => !value.includes('@'), {
    message: 'Invalid phone: contains @',
  })
  .refine(
    (value) => {
      const digits = value.replace(/\D/g, '');
      const nonSpaceLength = value.replace(/\s/g, '').length;
      return (
        nonSpaceLength === 0 ||
        digits.length / nonSpaceLength >= PHONE_MIN_DIGIT_RATIO
      );
    },
    { message: 'Invalid phone: mostly non-digit characters' }
  )
  .refine((value) => value.replace(/\D/g, '').length >= MIN_PHONE_DIGITS, {
    message: `Invalid phone: requires at least ${MIN_PHONE_DIGITS} digits`,
  })
  .transform((value) => value.replace(/\D/g, ''));

export const publicMarketplaceNameSchema = z
  .string()
  .max(MAX_NAME_LENGTH, `Name must be less than ${MAX_NAME_LENGTH} characters`)
  .transform(sanitizePublicMarketplaceString)
  .pipe(
    z
      .string()
      .trim()
      .min(1, 'Name is required')
      .max(
        MAX_NAME_LENGTH,
        `Name must be less than ${MAX_NAME_LENGTH} characters`
      )
  );

export const publicMarketplaceEmailSchema = z
  .string()
  .email('Invalid email address')
  .max(
    MAX_EMAIL_LENGTH,
    `Email must be less than ${MAX_EMAIL_LENGTH} characters`
  );
